import script from "./BusinessCardFields.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessCardFields.vue?vue&type=script&setup=true&lang=js"

import "./BusinessCardFields.vue?vue&type=style&index=0&id=745d259c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-745d259c"]])

export default __exports__